// Public landing page (/). Separate from the application pack so the
// landing page's Bootstrap 5 never loads alongside the React app's Bootstrap 4.

import '../landing/landing.scss'
